
import { FrontendFunc } from "@/models/frontend-func";
import { FrontendScriptsService } from "@/services/frontend-scripts-service";
import { SharedFuncReference } from "@/utils/shared-func-reference";
import Vue from "vue";
import { IDataTableColumn } from "winfakt-vue-components";

export default Vue.extend({
	data(){
		return {
			scripts: [] as FrontendFunc[],
			isFetching: false,
			selectedItems: [] as FrontendFunc[]
		};
	},
	props: {
		value: {
			type: Array as ()=>SharedFuncReference[],
			required: true
		}
	},
	computed: {
		columns():IDataTableColumn[] {
			let result:IDataTableColumn[] = [
				{
					name: "ID",
					property: "ID",
					width: "80px"
				},
				{
					name: "Naam",
					property: "Name",
					width: "200px"
				},
				{
					name: "Omschrijving",
					property: "Description",
					width: "800px"
				}
			];
			result.forEach(r=>r.disableSorting = true);
			return result;
		},
	},
	methods: {
		async fetch(){
			this.isFetching = true;
			try{
				this.scripts = await FrontendScriptsService.getFrontendSharedFuncs();
				this.scripts = this.scripts.filter(s=>this.value.findIndex(v=>v.FuncID == s.ID) == -1);
			}catch(err){
			}
			this.isFetching = false;
		},
		close(){
			this.$emit("close");
		},
		confirm(){
			this.value.push(...this.selectedItems.map(v=>v.toSharedFuncReference()));
			this.$emit("input", this.value);
			this.close();
		}
	},
	created(){
		this.fetch();
	}
});
